// extracted by mini-css-extract-plugin
export default {"errorModalMessage":"uzOc3"};